import { ContestStageValues as ContestStage } from 'contest/models/contest';
import { DispatcherInterface } from 'dispatchr';
import BaseStore from 'fluxible/addons/BaseStore';

type ContestLockState = 'unlocked' | 'held' | 'locked';

interface ContestStoreState {
    stage: ContestStage;
    lockState: ContestLockState;
    paymentRequired: boolean;
    privateContest: boolean;
}

export default class ContestStore extends BaseStore<ContestStoreState> {
    static storeName = 'ContestStore';

    private stage: ContestStage | null;
    private lockState: ContestLockState | null;
    private paymentRequired: boolean | null;
    private privateContest: boolean | null;

    constructor(dispatcher: DispatcherInterface) {
        super(dispatcher);
        this.stage = null;
        this.lockState = null;
        this.paymentRequired = null;
        this.privateContest = null;
    }

    init({ stage, lockState, paymentRequired, privateContest }: ContestStoreState) {
        this.stage = stage;
        this.lockState = lockState;
        this.paymentRequired = paymentRequired;
        this.privateContest = privateContest;
    }

    getStage() {
        return this.stage;
    }

    getLockState() {
        return this.lockState;
    }

    isPaymentRequired() {
        return this.paymentRequired;
    }

    isPrivate() {
        return this.privateContest;
    }
}
ContestStore.storeName = 'ContestStore';



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/contest-store.ts